import { useStyle } from "./style";
import { SystemAnnouncementBanner } from "@/widgets/system-announcement-banner/system-announcement-banner";
import { TrialIndicator } from "@/components";
import { useThemeComponent } from "@/contexts/theme/useThemeComponent";
import { useTheme } from "@/contexts/theme";
import { PrintHouseSwitcher } from "./components/print-house-switcher/print-house-switcher";
import { LineOfBusinessSelector } from "./components/line-of-business-selector/line-of-business-selector";
import { CustomTooltip } from "./components/custom-tooltip";
import { HeaderActions } from "./components/header-actions/header-actions";
import { UserProfileMenu } from "./components/user-profile-menu/user-profile-menu";

export { CustomTooltip };

const HeaderWidget = ({
  customStyle,
}: {
  customStyle?: React.CSSProperties;
}) => {
  const { classes } = useStyle();

  // Use theme-aware TrialIndicator (will use HpTrialIndicator when hp-client theme is active)
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  const ThemedTrialIndicator = useThemeComponent(
    "TrialIndicator",
    TrialIndicator,
  );

  return (
    <div style={{ ...classes.container, ...customStyle }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          gap: 8,
          minWidth: 0,
        }}
      >
        <PrintHouseSwitcher />
        <LineOfBusinessSelector />
        <ThemedTrialIndicator />
        <SystemAnnouncementBanner />
        <div style={{ flex: 1 }} />
      </div>
      <div style={classes.rightSideContainer}>
        <HeaderActions />
        {!isHpClient && <div style={classes.verticalDivider} />}
        <UserProfileMenu />
      </div>
    </div>
  );
};
export { HeaderWidget };
